export default __webpack_public_path__ + "static/media/5.26900373.jpeg";